export default "__VITE_PUBLIC_ASSET__2cbf9a12__"